import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="people-field"
export default class extends Controller {
  static targets = ['dropdown', 'children', 'adults']

  connect () {
    this.onClickOutside(this.element, () => this.hide())

    this.element.querySelectorAll('input').forEach((elem) => {
      elem.addEventListener('input', () => this.rebuildLabel())
    })
    this.rebuildLabel()
  }

  show () {
    this.dropdownTarget.classList.remove('d-none')
  }

  hide () {
    this.dropdownTarget.classList.add('d-none')
  }

  onClickOutside (element, callback) {
    document.addEventListener('click', e => {
      if (!element.contains(e.target)) callback()
    })
  };

  rebuildLabel() {
    this.childrenTarget.textContent = this.element.querySelector('input[name="children"]').value
    this.adultsTarget.textContent = this.element.querySelector('input[name="adults"]').value
  }
}
